import styled from "styled-components";

export const AddressContainer = styled.div`
  background: var(--background);
  padding: 12px;
  border-radius: 10px;
  margin: 12px 0;
  border: 1px solid var(--border);
`;

export const PickupBadge = styled.div`
  font-size: 13px;
  color: var(--text-main);
  margin: 12px 0;
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px;
  background: var(--background);
  border-radius: 8px;
  border: 1px dashed var(--border);
`;

export const MainAddressLine = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-bottom: 8px;

  .street-info {
    display: flex;
    flex-direction: column;
    strong {
      font-size: 14px;
      font-weight: 800;
      color: var(--text-main);
      text-transform: uppercase;
      line-height: 1.2;
    }
    span {
      font-size: 13px;
      color: var(--text-secondary);
      font-weight: 600;
    }
  }
`;

export const SecondaryInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  padding-left: 28px;
  font-size: 12px;
  color: var(--text-secondary);

  strong {
    color: var(--text-main);
  }
`;

export const ComplementBox = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  padding-left: 28px;
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid var(--border);
  font-size: 12px;
  color: #2563eb; /* Azul mantido para destaque de informação extra */
  font-weight: 700;
`;

export const ExtraInfoContainer = styled.div`
  margin: 12px 0;
  padding: 4px 0;
`;

export const PaymentRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: var(--text-secondary);
  margin-bottom: 8px;

  .label {
    font-weight: bold;
    color: var(--text-main);
  }
  .change {
    color: var(--secondary);
    font-weight: 600;
  }
`;

export const ObservationBox = styled.div`
  display: flex;
  gap: 8px;
  background: #fff1f2; /* Fundo rosado para atenção */
  border: 1px solid #fecdd3;
  padding: 10px;
  border-radius: 8px;
  color: var(--primary); /* Seu Vermelho Ninja */
  font-size: 12px;
  line-height: 1.4;

  svg {
    flex-shrink: 0;
  }
  strong {
    font-weight: 800;
  }
`;

export const TotalContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 12px;
  padding-top: 12px;
  border-top: 2px dashed var(--border);

  span {
    font-size: 11px;
    font-weight: 800;
    color: var(--text-secondary);
    letter-spacing: 0.5px;
  }

  strong {
    font-size: 18px;
    color: var(--secondary); /* Seu Verde de sucesso */
    font-weight: 900;
  }
`;

// Personalizações do item (o que tirou / pediu a mais) e observação do item.
export const Customizations = styled.span`
  display: flex;
  flex-wrap: wrap;
  gap: 4px 8px;
  margin-top: 2px;
  font-size: 12px;
  font-weight: 600;

  .removed {
    color: #ef4444;
  }
  .added {
    color: var(--secondary);
  }
  .composition {
    color: var(--text-secondary);
  }
  .note {
    color: var(--text-secondary);
    font-style: italic;
    font-weight: 500;
  }
`;
